import { useTranslation } from '@framework/i18n';
import { IconWrapper, ISODate } from '@framework/ui';
import { Button, message } from 'antd';
import { useCallback } from 'react';
import { FaCheck } from 'react-icons/fa';
import styled from 'styled-components';
import { useSetReadNotification } from './useSetReadNotification';

const SecondaryText = styled.span`
  color: ${props => props.theme.colorTextSecondary};
  font-size: 12px;
  display: inline-flex;
  line-height: 1.3;
  padding-bottom: 1px;
  span {
    margin-left: 5px;
  }
  .anticon {
    color: ${props => props.theme.colorPrimary};
  }
`;
const MinimalButton = styled(Button)`
  &&& {
    font-size: 13px;
    font-weight: 400;
    height: auto;
  }
`;

interface ButtonNotificationReadProps {
  read?: Date | null;
  notificationId: string;
}

/**
 * Pulsante per segnare una notifica come letta
 */
export function ButtonNotificationRead(props: ButtonNotificationReadProps) {
  const { read, notificationId } = props;
  const { t } = useTranslation();
  const readFn = useSetReadNotification(notificationId);

  const handleClick = useCallback(async () => {
    if (read) return;
    try {
      await readFn.mutateAsync({ idNotifica: notificationId });
    } catch (e) {
      console.error(`[ButtonNotificationRead] Error durante la lettura della notifica.`, {error: e}); // prettier-ignore
      message.error(
        t('notification.error', 'Si è verificato un errore, riprovare.'),
      );
    }
  }, [readFn, notificationId]);

  // if (readFn.isLoading) return <LoaderSpin size="small" />;
  const markAsReadText = t('notifiche.segna-come-letta', 'Segna come letta');

  const readText = t('notifiche.letta-il', 'Letta il');

  return (
    <>
      {read ? (
        <SecondaryText>
          {readText} <ISODate date={read} />{' '}
          <IconWrapper icon={<FaCheck aria-hidden="true" />} />
        </SecondaryText>
      ) : (
        <MinimalButton
          size="small"
          type="primary"
          ghost
          onClick={() => {
            handleClick();
          }}
        >
          {markAsReadText} <IconWrapper icon={<FaCheck aria-hidden="true" />} />
        </MinimalButton>
      )}
    </>
  );
}
